import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "langSelector_selected" }
const _hoisted_2 = {
  key: 0,
  class: "langSelector_dropdown"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "langSelector_flagPlaceholder" }
const _hoisted_5 = { class: "langSelector_itemText" }

import { ref, computed, PropType } from 'vue'
import useLang from '@web/composition/useLang'
import { availableLang } from '@web/common/locale'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'LangSelector'
},
  __name: 'langSelector',
  props: {
  fromMenu: {
    type: String as PropType<'navBarMobile' | 'settingsSidebar'>,
    default: ''
  }
},
  setup(__props) {





const showBlock = ref(false)

function onToggleBlock () {
  showBlock.value = !showBlock.value
}

const { selectedLang, setLang, lang } = useLang()

const otherLanguages = computed(() => {
  return Object.fromEntries(
    Object.entries(availableLang).filter(([key]) => key !== lang.value)
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["langSelector", [ showBlock.value ? '-open' : '', __props.fromMenu ? `-${__props.fromMenu}` : '' ]])
  }, [
    _createElementVNode("div", {
      class: "langSelector_trigger",
      onClick: onToggleBlock
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "langSelector_iconPlaceholder" }, [
        _createElementVNode("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12Z",
            stroke: "#A990E2",
            "stroke-width": "1.3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M12.9605 2C12.9605 2 15.842 5.96985 15.842 12C15.842 18.0301 12.9605 22 12.9605 22M11.0395 22C11.0395 22 8.15795 18.0301 8.15795 12C8.15795 5.96985 11.0395 2 11.0395 2M3 15.5176H21M3 8.48241H21",
            stroke: "#A990E2",
            "stroke-width": "1.3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ], -1)),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(selectedLang)), 1),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"langSelector_chevron\" data-v-8d845652><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8d845652><g clip-path=\"url(#clip0_21390_13964)\" data-v-8d845652><g clip-path=\"url(#clip1_21390_13964)\" data-v-8d845652><path d=\"M3.5 7L10 13L16.5 7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8d845652></path></g></g><defs data-v-8d845652><clipPath id=\"clip0_21390_13964\" data-v-8d845652><rect width=\"20\" height=\"20\" fill=\"white\" data-v-8d845652></rect></clipPath><clipPath id=\"clip1_21390_13964\" data-v-8d845652><rect width=\"20\" height=\"20\" fill=\"white\" data-v-8d845652></rect></clipPath></defs></svg></div>", 1))
    ]),
    _createVNode(_Transition, { name: "langSelector-dropdown" }, {
      default: _withCtx(() => [
        (showBlock.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherLanguages.value, (item, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "langSelector_item",
                  onClick: ($event: any) => (_unref(setLang)(key))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`langSelector_flagIcon -${key}`)
                    }, null, 2)
                  ]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item), 1)
                ], 8, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})